/**
 * Create Task Template API
 * Feature: Generic Configurable Task System
 * Branch: 022-i-like-all
 */

import axiosInstance from '@/api/axiosInstance';
import { CreateTaskTemplateRequest, TaskTemplateResponse } from './types';

export async function createTaskTemplate(
  data: CreateTaskTemplateRequest
): Promise<{ data: TaskTemplateResponse }> {
  const response = await axiosInstance.post<TaskTemplateResponse>(
    '/api/task-templates',
    data
  );

  return { data: response.data };
}